function deepClone(source) {
    if (source === undefined) {
        return source;
    }
    if (source === null || typeof source !== 'object') {
        return source;
    }
    if (Array.isArray(source)) {
        return source.map(deepClone);
    }
    var copiedObject = {};
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            copiedObject[key] = deepClone(source[key]);
        }
    }
    return copiedObject;
}
export default deepClone;
//# sourceMappingURL=deepClone.js.map